import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import NewIcon from 'ui/atoms/NewIcon/NewIcon'

type SettlementPeriodSummaryProps = {
  text: string
}

export function SettlementPeriodSummary({ text }: SettlementPeriodSummaryProps): ReactNode {
  const { t } = useTranslation()

  return (
    <div className="flex items-center gap-2 rounded-md border border-grey-3 bg-grey-1 px-3 py-2 text-xs text-grey-7">
      <NewIcon ariaLabel={t(`Period`)} icon="fal fa-calendar" color="grey" size="small" />
      <span>{text}</span>
    </div>
  )
}
